document.addEventListener('DOMContentLoaded', () => {
    const columns = document.querySelectorAll('.sychem-footer__links__column');
    let isAccordionInitialized = false; // Track whether the accordion is initialized

    function initAccordion() {
        if (!isAccordionInitialized && columns.length > 0 && window.innerWidth < 992) {
            columns.forEach(column => {
                column.addEventListener('click', toggleActive);
            });
            isAccordionInitialized = true; // Mark accordion as initialized
        }
    }

    function destroyAccordion() {
        if (isAccordionInitialized) {
            columns.forEach(column => {
                column.classList.remove('active');
                column.removeEventListener('click', toggleActive);
            });
            isAccordionInitialized = false; // Mark accordion as destroyed
        }
    }

    function toggleActive(event) {
        event.currentTarget.classList.toggle('active');
    }

    // Add debounce to resize event
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (window.innerWidth >= 992) {
                destroyAccordion();
            } else {
                initAccordion();
            }
        }, 100);
    });

    // Initialize accordion on page load
    window.addEventListener('load', () => {
        if (window.innerWidth < 992) {
            initAccordion();
        }
    });
});